import { NumberInput, type NumberInputProps } from "@mantine/core";

interface NumberFilterItemProps extends Pick<
  NumberInputProps,
  "rightSection" | "min" | "max"
> {
  filterValue?: number;
  label: string;
  onChange: (value?: number) => void;
}

function NumberFilterItem({
  filterValue,
  label,
  rightSection,
  max,
  min,
  onChange
}: NumberFilterItemProps) {
  return (
    <div>
      {label}:{" "}
      <NumberInput
        max={max}
        min={min}
        rightSection={rightSection}
        value={filterValue}
        onChange={(newValue) => {
          if (newValue === undefined || newValue === "") {
            onChange(undefined);
          } else {
            onChange(
              typeof newValue === "number" ? newValue : parseFloat(newValue)
            );
          }
        }}
      />
    </div>
  );
}

export { NumberFilterItem, NumberFilterItemProps };
